import React from 'react';
import '../UserAuthStateForm.scss';
export const AuthErrorMsg = ({ error, }) => (React.createElement(React.Fragment, null, error && (React.createElement("div", { className: "auth-error" },
    React.createElement("p", null, error)))));
//# sourceMappingURL=AuthErrorMsg.js.map